module.exports = "https://cdn2-fs.clearscore.com/flux/images/c4e81a63103b94ba6f85409c6342fcec.jpg";